import React from 'react';
import './index.scss';

const Answer = (props)=> {
  return (
      <div className="answer">
        <input onChange={props.handler} id={props.id} type="radio" value={props.value} name={props.set} />
        <label htmlFor={props.id}><svg viewBox="0 0 120 120"><circle cx="55" cy="55" r="35" className="fill" /><circle cx="55" cy="55" r="50" className="dotted" /><circle cx="55" cy="55" r="35" className="solid" /></svg><span className="footnote"><span className="icon-desc">{props.children}</span></span></label>
      </div>
  );
}

export default Answer;
